import JSON5 from "json5-with-undefined";
function stringifyDocValue(value) {
  return JSON5.stringify(value);
}
function parseDocValue(value) {
  return JSON5.parse(value);
}
export {
  parseDocValue,
  stringifyDocValue
};
//# sourceMappingURL=parse.js.map
